import React,{useEffect} from 'react';
import "./ArticleSec.scss";
import { Link } from 'react-router-dom';
import { GA_VPush,GA_Push } from '../Services/GoogleAnalytics';

export default function ArticleSec() {
    let items = [{ title: "20 הדקות ששינו את המזרח התיכון ", desc: "גורמי הביטחון לא הזהירו מראש את אריאל שרון, ראש הממשלה ברק פחד להתריע, וככה עליית יו\"ר האופוזיציה להר הבית, לפני 20 שנה, הפכה לגפרור שהצית את להבות האינתיפאדה. האנשים שהיו על ההר, משני עברי המתרס, והבכירים שידעו והזהירו משחזרים", link: "Sycj0bUEP" },
                 { title: "אנשי ההר" , desc: "עבור פח'רי מסגד אל-אקצא מסמל את החירות האיסאלמית ופגיעה בו היא קו אדום. תום נזעק מהאיסור על יהודים להתפלל בהר כיום ומייחל להקמת בית המקדש השלישי. שני אנשים, דתות שונות, מקום אחד", link: "B1vRC11L4D"},
                 { title: "הקרב ההלכתי על ההר" , desc: "שחרור הר הבית במלחמת ששת הימים הציף מחדש את המחלוקת האמונית ההיסטורית האם מותר לבקר במקום הקדוש ביותר ביהדות. לצד העמדה העקבית של הרבנות הראשית האוסרת את העלייה, מתרחבת המגמה בקרב רבנים שתומכים בעלייה להר", link: "Bkk9MNLVD"},
                 { title: '"החמצה גדולה מאוד"' , desc: "הר הבית הוא אחד האתרים המסקרנים ביותר מבחינה ארכיאולוגית – המקום שבו היה בית המקדש, כיפת הסלע, מסגד אל-אקצא. העובדה שמדובר במקום רגיש מבחינה דתית, שעורר לא פעם סכסוכים, גרמה לכך שהוא מעולם לא נחקר בצורה מעמיקה. זה מה שאנחנו יודעים בינתיים על הארכיאולוגיה בהר", link: "rkfaRW8ND"},
                ]
    // Thats For Analitics VPush
    useEffect(() => {
        //Sets the Observer options
        const options = {
            root: null, // The view port
            threshhold: 0.5, // 0 ~ 1
            rootMargin: "0px", // like margin in css
        };
        // const observer = new IntersectionObserver(function (entries, observer) {
        //     entries.forEach((entry) => {
        //     if (!entry.isIntersecting)return;
        //     const h1 = entry.target.querySelector("h1").innerText
        //     GA_VPush(`/communities/${h1}` , `${h1}`)
        //     observer.unobserve(entry.target);
        //     })
        // }, options);
        // const wantedNodes = document.querySelectorAll(".c_watch");
        // wantedNodes.forEach((li) => {
        //     observer.observe(li);
        // });
        }, []);

        // Thats for animations
        useEffect(() => {
        // Sets the Observer options
        const options = {
            root: null, // The view port
            threshhold: 0.5, // 0 ~ 1
            rootMargin: "0px", // like margin in css
        };
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            // Do the action on intersect section
            entry.target.classList.add("animate_in")
            })
        }, options);
        const wantedNodes = document.querySelectorAll(".watch_animate");
        wantedNodes.forEach((li) => {
            observer.observe(li);
        });
        }, []);

        function handleNavigation(title){
            GA_Push("navigation_events" , "Click to Article",title , "navigation")
        }

    return (
        <section className="article_sec">
             {/* <div className="fight_title a_sec">כותרת לכתבות<div className="rect a_sec"></div><div className="top_line"></div></div> */}
             {
                 items.map((a , i) => (
                     <div key={a.link} className="item_wrapper watch watch_animate">
                         <div className="image_wrapper">
                             <div className={`item_image item_${i+1}`}></div>
                             <div className="black_line"></div>
                         </div>
                         <div className="content_wrapper">
                            <div className="item_title">{a.title}</div>
                             <div className="item_desc">{a.desc}</div>
                             <a href={"https://www.ynet.co.il/news/article/" + a.link} target="_blank" className="article_link" onClick={() => handleNavigation(a.title)}>לקריאת הכתבה<div className="black_rect"></div></a>
                         </div>
                     </div>
                 ))
             }
        </section>
    )
}
